import { Resources } from 'constants/resources';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Link } from 'react-router-dom';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';

type Props = DialogProps & {
  requestId: string;
};

export const OrderAdjustmentsSuccessDialog = ({ open, onClose, requestId }: Props) => {
  const translate = useTypedTranslate();
  const { createPathWithQuery } = useCreatePathWithQuery();

  return (
    <Dialog maxWidth="sm" onClose={onClose} open={open}>
      <CardHeader
        appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
        title={translate('app.orderAdjustments.successDialog.title')}
        titleSize="smallBold"
      />
      <CardContent>
        <Typography>{translate('app.orderAdjustments.successDialog.message')}</Typography>
      </CardContent>
      <CardActionsButtons
        rightActionsSlot={[
          <CancelButton
            key="cancel-button"
            label={translate('app.orderAdjustments.successDialog.close')}
            onClick={onClose}
            variant="outlined"
          />,
          <Button
            component={Link}
            key="save-button"
            label={translate('app.orderAdjustments.successDialog.goToReport')}
            target="_blank"
            to={createPathWithQuery(
              {
                resource: Resources.OrderAdjustmentsReport,
                type: 'list',
              },
              {
                filter: {
                  requestId,
                },
              },
            )}
            variant="contained"
          />,
        ]}
      />
    </Dialog>
  );
};
